var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-cursor",style:(_vm.computedPosition)},[_c('div',{staticClass:"custom-cursor-object"},[_vm._v("click")])])}
var staticRenderFns = []

export { render, staticRenderFns }